<app-header *ngIf="!hiddenSection"></app-header>
<div class="content" [ngStyle]="{'min-height': (hiddenSection) ? '' : contentHeight}">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!hiddenSection"></app-footer>
<app-event-alert *ngIf="isEvent" [eventData]="eventData" (closeDialog)="closeDialog()"></app-event-alert>
